import { create } from 'zustand'

interface MobileSidebarStore {
  filterDock: boolean
  setFilterDock: (val: boolean) => void
  taxation: boolean
  setTaxation: (val: boolean) => void
  exports: boolean
  setExports: (val: boolean) => void
  account: boolean
  setAccount: (val: boolean) => void
}

export const useMobileSidebarStore = create<MobileSidebarStore>()((set, get) => ({
  filterDock: false,
  setFilterDock: (val: boolean) => {
    if (get().filterDock !== val) set({ filterDock: val })
  },
  taxation: false,
  setTaxation: (val: boolean) => {
    if (get().taxation !== val) set({ taxation: val })
  },
  exports: false,
  setExports: (val: boolean) => {
    if (get().exports !== val) set({ exports: val })
  },
  account: false,
  setAccount: (val: boolean) => {
    if (get().account !== val) set({ account: val })
  },
}))
